import React , { Component } from 'react';
import Agent from "../../Network/Agent";
import ButtonPrimary from "../Elements/ButtonPrimary";
import {getGeneratedRoute, RouteEnumFinal} from "../../Config/RouteEnum";
import mapboxgl from 'mapbox-gl';
import {Modal} from "react-bootstrap";
import ToolBar from "../Elements/ToolBar";

mapboxgl.accessToken = 'pk.eyJ1IjoiYmVobmFtbmFzZWhpIiwiYSI6ImNsNnQ3b2ZvaTEwZ3Eza3BicGh4dzljcG8ifQ.M7HkFBKF-KRyFqHT3wRXhw';
if (mapboxgl.getRTLTextPluginStatus() !== 'loaded') {
    mapboxgl.setRTLTextPlugin(
        'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
        (): void => {},
        true // Lazy load the plugin only when text is in arabic
    )
}

class AddressAdd extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // storeUsername : window.location.pathname.split('/')[1],
            storeUsername : window.location.host.split('.')[0],
            addressCode : window.location.pathname.split('/')[4] ?? null,
            isLoading : {
                map : false,
                address : false,
            },
            lng: 51.3996,
            lat: 35.7273,
            zoom: 15,
            modal : {
                address : false
            },
            address : {
                title : '',
                receiver : '',
                phoneNumber : '',
                country : '',
                county : '',
                province : '',
                zipCode : '',
                location : {},
                address : ''
            },
        }
        this.mapContainer = React.createRef();
    }

    toggleModal = (target) => e => {
        let modal = this.state.modal
        modal[target] = !modal[target]
        this.setState({
            modal
        })
    }

    onSubmitMap = () => {
        this.setState({
            isLoading : {
                map : true
            }
        })
        Agent.Map.getInfo(this.state.lat , this.state.lng)
            .then(response => {
                console.log(response)
                this.setState({
                    isLoading : {
                        map : false
                    }
                })
                let map = response.data.result.map
                this.setState({
                    address : {
                        location : {
                            type : 'Point',
                            coordinates : [
                                this.state.lat ,
                                this.state.lng
                            ]
                        },
                        country : map.country.code,
                        county : map.county.code,
                        province : map.province.code
                    },
                    modal : {
                        address : true
                    }
                })
            })
            .catch(error => {
                console.log(error)
                this.setState({
                    isLoading : {
                        map : false
                    }
                })
            })
    }

    onChangeInput = (name) => e => {
        let value = e.target.value
        let address = this.state.address
        address[name] = value
        this.setState({
            address : address
        })
    }

    onSubmitFormAddress = (e) => {
        e.preventDefault()
        this.setState({
            isLoading : {
                address : true
            }
        })
        Agent.Address.create(this.state.address)
            .then(response => {
                this.setState({
                    isLoading : {
                        address : false
                    }
                })
                window.location = getGeneratedRoute(RouteEnumFinal.ADDRESS_LIST_URL_GENERATE , this.state.storeUsername)
                /*if (response.data.action === ActionResponseEnum.REDIRECT) {
                    window.location = response.data.next
                }*/
            })
            .catch(error => {
                console.log(error.response)
                this.setState({
                    isLoading : {
                        address : false
                    }
                })
            })
    }

    componentDidMount() {


        const { lng, lat, zoom } = this.state;
        const map = new mapboxgl.Map({
            container: this.mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [lng, lat],
            zoom: zoom,
        });
        let currentLat,
            currentLong;
        navigator.geolocation.getCurrentPosition(function (position){
            map.flyTo({
                center: [position.coords.longitude, position.coords.latitude],
                essential : true
            })
        })
        map.on('move', () => {
            this.setState({
                lng: map.getCenter().lng.toFixed(4),
                lat: map.getCenter().lat.toFixed(4),
                zoom: map.getZoom().toFixed(2)
            });
        });

        if (this.state.addressCode !== null) {
            Agent.Address.getInfo(this.state.addressCode)
                .then(response => {
                    let location = response.data.result.address.location.coordinates
                    let responseAddress = response.data.result.address
                    let address = this.state.address
                    address['title'] = responseAddress.title
                    address['receiver'] = responseAddress.receiver
                    address['phoneNumber'] = responseAddress.phoneNumber
                    address['zipCode'] = responseAddress.zipCode
                    address['address'] = responseAddress.address
                    address['location'] = responseAddress.location
                    address['country'] = responseAddress.country.code
                    address['county'] = responseAddress.county.code
                    address['province'] = responseAddress.province.code

                    this.setState({
                        lat : location[1],
                        lng : location[0],
                        address : address,
                    })
                    map.flyTo({
                        center: [location[1] , location[0]],
                        essential : true
                    })
                })
                .catch(error => {
                    console.log(error.response)
                })
        }
    }

    render() {
        return(
            <>
                <ToolBar title={'افزودن آدرس'} url={getGeneratedRoute(RouteEnumFinal.STORE_PANEL_URL_GENERATE)} />
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='mobile-subtitle-regular cl-subtitle mt-22'>
                                لطفا موقعیت مکانی فروشگاه خود را انتخاب کنید.
                            </div>
                        </div>
                    </div>
                </div>
                <div className='map-container-custom'>
                    <div className='map-pin'>
                        <div className="img-cnt-36">
                            <img src={"/assets/images/vectors/map_pin_black.svg"}/>
                        </div>
                    </div>
                    <div className='faded-cover'/>
                    <div ref={this.mapContainer} className="map-container" />
                </div>
                <div className='btn-fixed-bottom'>
                    <div className='td-none' onClick={this.onSubmitMap}>
                        <ButtonPrimary mode='dark-mode' text='همینجا درسته !' isLoading={this.state.isLoading.map} />
                    </div>
                </div>

                <Modal className='bottom-sheet fade in'
                       show={this.state.modal.address}
                       onHide={this.toggleModal('address')}>
                    <Modal.Body style={{maxHeight : '75vh' , overflowY : 'auto'}}
                                className='custom-scrollbar-1'>
                        <div className='d-flex justify-content-center pt-10 pb-10' onClick={this.toggleModal('address')}>
                            <div className='bottom-sheet-close-line btn p-0 ' />
                        </div>

                        <div className='d-flex justify-content-between align-content-lg-between mt-20'>
                            <div className='mobile-h5 cl-black'>
                                افزودن موقعیت مکانی
                            </div>
                            <div className='mobile-h5 cl-blue' onClick={this.toggleModal('address')}>
                                بستن
                            </div>
                        </div>

                        <form id='form_submit_address' onSubmit={this.onSubmitFormAddress}>
                            <div className='form-group-input-primary mt-32'>
                                <div className='mobile-subtitle-regular cl-subtitle mt-20'>
                                    لطفا یک نام برای آدرس خود انتخاب کنید :
                                </div>
                                <label className="form-group-label mt-8">
                                    <input id='input_title'
                                           value={this.state.address.title}
                                           onChange={this.onChangeInput('title')}
                                           type="text"
                                           className='form-group-input'
                                           placeholder='نام:آدرس، خونه، محل کار'/>
                                </label>
                            </div>
                            <div className='form-group-input-primary mt-32'>
                                <div className='mobile-subtitle-regular cl-subtitle mt-20'>
                                    کد پستی محل انتخاب شده را وارد کنید :
                                </div>
                                <label className="form-group-label mt-8">
                                    <input id='input_postal_code'
                                           value={this.state.address.zipCode}
                                           onChange={this.onChangeInput('zipCode')}
                                           type="text"
                                           className='form-group-input'
                                           placeholder='کد پستی : 41996465'/>
                                </label>
                            </div>
                            <div className='form-group-input-primary mt-32'>
                                <div className='mobile-subtitle-regular cl-subtitle mt-20'>
                                    نام گیرنده :
                                </div>
                                <label className="form-group-label mt-8">
                                    <input id='input_receiver'
                                           value={this.state.address.receiver}
                                           onChange={this.onChangeInput('receiver')}
                                           type="text"
                                           className='form-group-input'
                                           placeholder='نام  : بهنام ناصحی'/>
                                </label>
                            </div>
                            <div className='form-group-input-primary mt-32'>
                                <div className='mobile-subtitle-regular cl-subtitle mt-20'>
                                    شماره تماس گیرنده :
                                </div>
                                <label className="form-group-label mt-8">
                                    <input id='input_phone_number'
                                           value={this.state.address.phoneNumber}
                                           onChange={this.onChangeInput('phoneNumber')}
                                           type="text"
                                           className='form-group-input'
                                           placeholder='شماره تماس  : 09369565656'/>
                                </label>
                            </div>
                            <div className='form-group-textarea-primary mt-32'>
                                <div className='mobile-subtitle-regular cl-subtitle mt-20'>
                                    محل دقیق آدرس خود را وارد کنید :
                                </div>
                                <textarea id='textarea_body'
                                          value={this.state.address.address}
                                          onChange={this.onChangeInput('address')}
                                          placeholder='مثال : رشت منظریه ولی عصر'
                                          className="form-group-textarea mt-8"/>
                            </div>
                        </form>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className='w-100'>
                            <div onClick={this.onSubmitFormAddress}>
                                <ButtonPrimary text='تایید'
                                               mode='dark-mode'
                                               isLoading={this.state.isLoading.address} />
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}


export default AddressAdd